import { checkIsLoggedIn } from "@services/client/user-service";
import { getDeviceModel, getDevicePlatform } from "./device-utils";

export const getSegmentEventCommonProps = async () => {
  const { user: userData } = await checkIsLoggedIn()
  const deviceType = getDeviceModel();
  let url = "";
  let source = "";

  if (typeof window !== "undefined") {
    url = window.location.href || "";
    source = document.referrer || "";
  }

  const queryParams =
    typeof window !== "undefined"
      ? new URLSearchParams(window.location.search)
      : null;
  return {
    device_model: deviceType,
    phone: userData?.phone || "",
    email: userData?.email || "",
    dob: userData?.date_of_birth || "",
    address: userData?.addresses?.[0] || {},
    from_page: source,
    platform: getDevicePlatform(),
    utm_source: queryParams ? queryParams.get("utm_source") || "" : "",
    utm_campaign: queryParams ? queryParams.get("utm_campaign") || "" : "",
    utm_content: queryParams ? queryParams.get("utm_content") || "" : "",
    utm_medium: queryParams ? queryParams.get("utm_medium") || "" : "",
    url,
  };
};
